<template>
<div class="cp-calendar calendar-body">
  <msp-app-bar></msp-app-bar>
  <v-sheet
      tile
      height="54"
      color="grey lighten-3"
      class="calendar-nav d-flex"
  >
      <v-btn
          @click="openMiglioriPrestazioni"
          color="white"
          class="ma-2 btn-record">
          <span>
              <i class="v-icon msp-icon-award"></i>
          </span>
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn
          class="ma-2"
          @click="toggleCalendar()"
      >
          <span v-if="collapsed">
              <v-icon title="mostra calendario">mdi-calendar-search</v-icon>      
          </span>
          <span v-else>
              <v-icon title="nascondi calendario">mdi-calendar-minus</v-icon>      
          </span>
      </v-btn>
      <v-spacer></v-spacer>
      
     
      <v-btn
          @click="forceGoToTodayIfNeeded()"
          class="ma-2 cal-today">
          oggi
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn
          @click="refresh()"
          class="ma-2 cal-today">
          <v-icon>mdi-refresh</v-icon>
      </v-btn>
  </v-sheet>
    <v-sheet
    class="calendar-container"
    :class="classCalendar"
    >

    <vc-calendar
    ref="calendar"
    locale="it"
    :attributes="calendarEvents"
    @dayclick="goToDayFromCalendar"
    ></vc-calendar>

    </v-sheet>


<v-sheet
class="calendar-list mx-auto"
ref="calendar-list"
v-if="days"
>



<div class="calendar-cells">
<!-- una settimana per componente: a ogni caricamento si disegnano solo le
     settimane nuove o cambiate (v. settimaneVista) -->
<msp-calendario-settimana
v-for="settimana in settimaneVista"
:key="'week-'+settimana.monday"
:settimana="settimana"
:parametri="parametri"
:today="today"
@open-modal="openModal"
@open-attivita="openAttivita"
@open-chat-calendario="openChatCalendario"
></msp-calendario-settimana>
</div>


</v-sheet>
<v-sheet v-if="!atleta && !(days && days.length)">
<v-alert type="info">Nessun calendario selezionato</v-alert></v-sheet>
<v-snackbar
v-model="loading"
>
<v-btn
icon

:loading="loading"
></v-btn>

carico

</v-snackbar>
<v-dialog
v-model="showFabModal"
transition="dialog-bottom-transition"
>
</v-dialog>
 <v-speed-dial
 absolute
 v-show="canShowFab"
      v-model="fab"
      direction="top"
      :fab="false"
      :fling="false"
      :hover="false"
      :tabs="null"
      :top="false"
      :right="true"
      :bottom="true"
      :transition="'slide-y-reverse-transition'"
    >
      <template v-slot:activator>
        <v-btn
          v-model="fab"
          color="blue darken-2"
          dark
          fab
        >
          <v-icon v-if="fab">
            mdi-close
          </v-icon>
          <v-icon v-else>mdi-plus</v-icon>
          
        </v-btn>
      </template>
      <v-btn v-for="(fab,index) in filteredFab"
      :key="index"
        fab
        dark
        small
        :color="fab.color"
        @click="handleClickFab(...fab.click)" 
      >
      <span class="fab-label">{{fab.label}}</span> 
      <i v-if='fab.icon' :class="'msp-flat-icon ' + fab.icon"></i>
      <v-icon v-if='fab.md'>{{fab.md}}</v-icon>
      </v-btn>
    </v-speed-dial>
    <v-overlay 
    :value="fab"
    :opacity="0.8"
    :z-index="0"
    ></v-overlay>
    
    <msp-app-footer></msp-app-footer>

<v-dialog
v-model="showModal"
scrollable
fullscreen
hide-overlay
transition="slide-x-transition"
:return-value="'detail'"
>
<router-view></router-view>
</v-dialog>

<msp-libreria-allenamenti
  v-model="showLibreria"
  :atleta-id="atletaId ? +atletaId : null"
  @added="onLibreriaAdded"
></msp-libreria-allenamenti>

      </div>
</template>

<script>

import {fab as dataFab} from "@data/fab.js"
import moment from "moment";
import api from "@mixins/api.js";
import messaggi from "@mixins/messaggi.js";
import env from "@mixins/environment.js"
import MspLibreriaAllenamenti from "@components/MspLibreriaAllenamenti.vue";
import MspCalendarioSettimana from "@components/MspCalendarioSettimana.vue";
import MspAppBar from "@components/MspAppBar.vue";
import MspAppFooter from "@components/MspAppFooter.vue";
import {  mapState, mapGetters } from 'vuex'
import allenamentoCalcoli from "@src/js/vue/mixins/allenamentoCalcoli.js";
import _cal from "@src/js/vue/mixins/calendario.js";
import _funzioni from "@src/js/msp/funzioni.js";
import version from "@mixins/version.js"

moment.locale("it");

/** true se i due array hanno gli stessi elementi (per riferimento) nello stesso ordine */
const stessiElementi = function (a, b) {
    if (a === b) return true;
    if (!(a && b) || a.length !== b.length) return false;
    for (let i = 0; i < a.length; i++) {
        if (a[i] !== b[i]) return false;
    }
    return true;
};
const NESSUNO = Object.freeze([]);

const raggruppaPerSettimana = function (lista, dataDi) {
    const out = new Map();
    lista.forEach((el)=>{
        const monday = _cal.getMonday(dataDi(el));
        if (!out.has(monday)) out.set(monday, []);
        out.get(monday).push(el);
    });
    return out;
};

/** scroll infinito: distanza dal bordo (px) sotto la quale si carica la settimana
 * precedente. In alto resta piccola: il caricamento in testa riposiziona lo scroll,
 * che su iOS interrompe l'inerzia. */
const SOGLIA_PREV = 20;

const component = {
  
  mixins: [
    allenamentoCalcoli,
    env,
    version,
  ],

  components: {
    MspLibreriaAllenamenti,
    MspCalendarioSettimana,
    MspAppBar,
    MspAppFooter,
  },

  beforeDestroy: function () {
      if (this._scrollEl) {
          this._scrollEl.removeEventListener('scroll',this.onCalendarScroll);
      }
      if (this._osservatoreSettimane) {
          this._osservatoreSettimane.disconnect();
      }
  },

  watch: {
      atletaId: function () {
          this.initCalendar();
      },
    dialog: function (val) {
      this.showModal = val;
      },

    $route: {
      immediate: true,
      handler: function(newVal) {
        this.showModal = newVal.meta && newVal.meta.showModal;
      }
    }

  },

  /**
   * TODO: gestire l'allenatore in modo globale.
   * In base alla condizione isCoach, carica delle parti o altre.
   */

  mounted: async function () {
      this.$forceNextTick(()=>{
          this._scrollEl = this.getListaDOM();
          if (this._scrollEl) {
              this._scrollEl.addEventListener('scroll',this.onCalendarScroll, {passive: true});
          }
      })
      this.current =  this.$route.query.day;


      this.loadParametri();
      this.isCoach = this.utente && !this.utente.is_atleta;
      if (!this.isCoach) {
          this.checkAlertAutovalutazione()
              .then(async (result)=>{
                  let interval;
                  if(result.interval) {
                      interval = result.interval;
                  } else {
                      interval = 0;
                  }
                  this.showAlertAutovalutazioneIfNeeded(result.last, interval);
              });
      }
      this.initCalendar();
  },

created () {
    // stato interno non reattivo
    this._scrollEl = null;
    this._osservatoreSettimane = null;
    // ultime settimane calcolate da settimaneVista, per monday: ne riusa gli
    // oggetti quando non cambiano
    this._settimaneVista = new Map();
    // ultimo giorno visibile comunicato allo store e al mini calendario
    this._giornoCorrente = null;
    // navigazione a un giorno in corso (v. naviga): scroll infinito sospeso
    this._navigando = false;
    // un'istanza sola: creata a ogni evento di scroll, il debounce non avrebbe effetto
    this._aggiornaGiornoCorrente = _funzioni.debounce(this.updateCurrentDay, 150);
},

data: () => ({
    pullController: null,
    parametri: [],
    tab: null,
    tabs: [
        { id: 1,
            text: 'atleti',
            icon: 'mdi-account',
        },
        { id: 2,
            text: 'feedback',
            icon: 'mdi-note-text',
        },
        { id: 3,
            text: 'zone',
            icon: 'mdi-heart',
        },
        { id: 4,
            text: 'esporta',
            icon: 'mdi-upload',
        },
    ],
    isCoach: false,
    fab: false,
    showLibreria: false,
    dataFab: dataFab,
    loading: false,
    showModal: false,
    showFabModal: false,
    canScroll: true,
    canLoad: true,
    loadingRange: false,
    from: _cal.date2ymd(),
    to: _cal.date2ymd(),
    today: _cal.date2ymd(),
    primoElementoVisibile: {
        element: null,
        y: 1000,
    },
    current: false,
    type: 'month',
    types: ['month', 'week', 'day', '4day'],
    weekday: [1, 2, 3, 4, 5, 6, 0],
    value: '',
    collapsed: true,
    days: [],
    start: _cal.date2ymd(),
    end: '',
}),

computed: {
    ...mapState(
        {
            currentDay: (state)=>state.calendario.currentDay,
                dialog: (state)=>state.calendario.dialog,
                attivita: (state)=>state.calendario.attivita,
                peso: (state)=>state.calendario.peso,
                calendarEvents: (state)=>state.calendario.calendarEvents,
                limits: (state)=>state.calendario.limits,
        }
    ),
    ...mapGetters('calendario', [
        'impegni',
        'misurazioni',
        'events',
    ]),
    ...mapGetters('atleti', [
        'atleti',
        'atleta',
        'atletaId',
    ]),
    ...mapGetters('utente', [
        'utente',
    ]),

    filteredFab: function () {
        let k = (this.isCoach) ? 'allenatore' : 'atleta';
        return this.dataFab[k];
    },

    classCalendar ()
    {
        return (this.collapsed) ? "collapsed" : "";
    },

    filteredTabs: function () {
        let tabs = [...this.tabs];
        return tabs;
    },

    canShowFab: function () {
        return this.atleta;
    },
    attivitaAssociate: function () {
        return new Set(this.events.filter(el=>el.data.attivita).map(el=>el.data.attivita.id));
    },

    /** Le settimane caricate con i loro dati (eventi, attività non associate,
     * misurazioni, impegni), una per MspCalendarioSettimana.
     * Una settimana che non è cambiata resta lo stesso oggetto, con gli stessi
     * array: il suo componente non si ridisegna. Così un caricamento (scroll
     * infinito) o la modifica di un evento disegnano solo le settimane toccate.
     */
    settimaneVista: function () {
        const precedenti = this._settimaneVista;
        const associate = this.attivitaAssociate;

        const items = raggruppaPerSettimana(this.events || [], el=>el.data.data);
        const attivita = raggruppaPerSettimana(
            (this.attivita || []).filter(el=>!associate.has(el.id)),
            el=>el.start_ymd
        );
        const misurazioni = raggruppaPerSettimana(this.misurazioni || [], el=>el.data);
        const impegni = this.impegni || [];

        const giorniPerSettimana = new Map();
        this.days.forEach((day)=>{
            const monday = _cal.getMonday(day.date);
            if (!giorniPerSettimana.has(monday)) giorniPerSettimana.set(monday, []);
            giorniPerSettimana.get(monday).push(day);
        });

        const settimane = [];
        giorniPerSettimana.forEach((days, monday)=>{
            const vecchia = precedenti.get(monday);
            const riusa = (nuovo, chiave) => (vecchia && stessiElementi(vecchia[chiave], nuovo)) ? vecchia[chiave] : nuovo;
            const domenica = _cal.addDays(monday, 6);
            const impegniSettimana = impegni.filter(el=>{
                const fine = el.end_ymd || el.start_ymd;
                return el.start_ymd <= domenica && fine >= monday;
            });

            const settimana = {
                monday: monday,
                days: (vecchia && stessiElementi(vecchia.days.map(d=>d.date), days.map(d=>d.date))) ? vecchia.days : days,
                items: riusa(items.get(monday) || NESSUNO, 'items'),
                attivita: riusa(attivita.get(monday) || NESSUNO, 'attivita'),
                misurazioni: riusa(misurazioni.get(monday) || NESSUNO, 'misurazioni'),
                impegni: riusa(impegniSettimana.length ? impegniSettimana : NESSUNO, 'impegni'),
            };
            const invariata = vecchia
                && ['days', 'items', 'attivita', 'misurazioni', 'impegni'].every(k=>vecchia[k] === settimana[k]);
            settimane.push(invariata ? vecchia : settimana);
        });

        this._settimaneVista = new Map(settimane.map(s=>[s.monday, s]));
        return settimane;
    },
},


methods: {
        getListaDOM: function () {
            return this.$el.querySelector('.calendar-list');
        },

        /** Salta stili, impaginazione e disegno delle settimane lontane dalla vista
         * (classe calendar-week--fuori, content-visibility: hidden). Un
         * IntersectionObserver sul contenitore di scroll, con un margine di una vista
         * sopra e sotto, toglie la classe quando la settimana si avvicina. Prima di
         * nasconderla ne fissa l'altezza reale (contain-intrinsic-size), così lo
         * scroll non cambia. Richiamato dopo ogni updateCalendar: osserva di nuovo
         * tutte le settimane, anche quelle aggiunte.
         */
        osservaSettimane: function () {
            const container = this._scrollEl || this.getListaDOM();
            if (!(container && typeof IntersectionObserver !== 'undefined')) return;
            if (!this._osservatoreSettimane) {
                this._osservatoreSettimane = new IntersectionObserver((entries)=>{
                    // prima tutte le letture, poi le scritture: alternarle forzerebbe
                    // un'impaginazione per ogni settimana
                    const daNascondere = entries
                        .filter(e=>!e.isIntersecting && !e.target.classList.contains('calendar-week--fuori'))
                        .map(e=>({el: e.target, altezza: e.target.offsetHeight}))
                        .filter(s=>s.altezza > 0);
                    entries
                        .filter(e=>e.isIntersecting)
                        .forEach(e=>e.target.classList.remove('calendar-week--fuori'));
                    daNascondere.forEach(({el, altezza})=>{
                        el.style.containIntrinsicSize = `auto ${altezza}px`;
                        el.classList.add('calendar-week--fuori');
                    });
                }, { root: container, rootMargin: '100% 0px' });
            }
            this._osservatoreSettimane.disconnect();
            container.querySelectorAll('.calendar-week')
                .forEach(el=>this._osservatoreSettimane.observe(el));
        },
    initCalendar: async function () {
        if (!(this.atleta && this.atleta.id)) return;
        if (this.events && this.events.length) {
            if (this.currentDay) {
                await this.goToDay(this.currentDay);
            }
            return;
        }
        await this.naviga(this.current || _cal.date2ymd());
    },
    handleClickFab: function (fn,...args) {
        if (!args.length) {
            return this[fn]();
        } else {
            return this[fn](...args);
        }
    },

    loadParametri: async function () {
        const url = this.api_base_url +  '/api/v2/misurazione.php?parametri';
        const result = await api(url, "GET");
        if (!(result.success)) {
            this.parametri = [];
            return;
        }
        this.parametri = result.data;
    },

    setLastAlertAutovalutazione: function () {
        let url = this.api_base_url+"/api/v2/autovalutazione_atleta.php?last-alert";
        let data = {
            "value": _cal.date2ymd(),
        }
        return new Promise((resolve,reject)=>{
            api(url,'post', data)
                .then((result)=>{
                    if (result.success) {
                        resolve(result);
                    } else {
                        resolve(null);
                    }
                })
                .catch((error)=>{
                    reject(error);
                })
        });


    },
    setIntervalAutovalutazione: function () {
        let url = this.api_base_url+"/api/v2/autovalutazione_atleta.php?interval-alert";
        return new Promise((resolve,reject)=>{
            api(url,'post', null)
                .then((result)=>{
                    if (result.success) {
                        resolve(result.data);
                    } else {
                        resolve(null);
                    }
                })
                .catch((error)=>{
                    reject(error);
                })
        });


    },

    showAlertAutovalutazioneIfNeeded: function (last, interval) {
        if (!interval) return;
        if (!last) {
            this.showAlertAutovalutazione();
        } else {
            let prossimo =_cal.addDays(last, interval);
            let oggi = _cal.date2ymd();
            let prossimoDate = _cal.utcDate(prossimo);
            let oggiDate = _cal.utcDate(oggi);
            let diff = (prossimoDate - oggiDate) / 3600/24/1000;
            if (diff<1) {
                this.showAlertAutovalutazione();
            }
        }
    },
    showAlertAutovalutazione: function () {
        this.addMisurazioneFromFab();
    },

    checkAlertAutovalutazione: function () {
        let url = this.api_base_url+"/api/v2/autovalutazione_atleta.php?last-alert";
        return new Promise((resolve,reject)=>{
            api(url,'get', null)
                .then((result)=>{
                    if (result.success) {
                        resolve(result.data);
                    } else {
                        resolve(null);
                    }
                })
                .catch((error)=>{
                    reject(error);
                })
        });

    },

    /** primo elemento con il bordo (top o bottom) sotto il bordo superiore del contenitore */
    findFirst: function (arr, container, bordo = 'top') {
        let top = container.getBoundingClientRect().top;
        for (let i = 0; i< arr.length ; i++) {
            let y= arr[i].getBoundingClientRect()[bordo];
            if (y > top) {
               return  arr[i];
            }
        }
        return arr[arr.length-1];
    },

    openMiglioriPrestazioni: function () {
        this.$router.push("/record");
    },
    /** Primo giorno visibile: cerca prima la settimana, poi il giorno al suo
     * interno. Leggere la posizione di tutti i giorni costringerebbe il browser a
     * impaginare anche le settimane nascoste (calendar-week--fuori). */
    getFirstDay: function (container) {
        const weeks = container.querySelectorAll('.calendar-week');
        if (!weeks.length) return null;
        const week = this.findFirst(weeks, container, 'bottom');
        return this.findFirst(week.querySelectorAll('.calendar-day'), container);
    },

    updateCurrentDay: function () {
        const container = this._scrollEl;
        if (!container) return;
        const el = this.getFirstDay(container);
        const currentDay = el && el.dataset.day;
        if (currentDay && currentDay !== this._giornoCorrente) {
            this._giornoCorrente = currentDay;
            this.$store.dispatch("calendario/setCurrentDay", currentDay);
            this.focusDay(currentDay);
        }
    },

    /** Scroll infinito: la vicinanza ai bordi si legge a ogni evento (scrollTop e
     * scrollHeight, nessuna impaginazione); il giorno corrente solo a scroll fermo. */
    checkInfiniteScroll: function () {
        const container = this._scrollEl;
        if (!container || this._navigando) return;
        const daFondo = container.scrollHeight - container.scrollTop - container.clientHeight;
        if (container.scrollTop < SOGLIA_PREV) {
            this.loadPrev();
        } else if (daFondo < container.clientHeight) {
            // in fondo si carica con una vista d'anticipo: aggiungere in coda non
            // sposta lo scroll
            this.loadNext();
        }
    },

    onCalendarScroll: function () {
        this.checkInfiniteScroll();
        this._aggiornaGiornoCorrente();
    },



    loadCalendarEvents: async function (ev) {
        let limits = {
            start: _cal.date2ymd(new Date(ev.year, ev.month-1,1)),
            end: _cal.date2ymd(new Date(ev.year, ev.month,1)),
        }
        this.loading = true;
        await this.$store.dispatch("calendario/loadCalendarEvents", limits);

        this.loading = false;
    },



    openFabModalImpegno: function () {
        // come la gara: l'impegno viene creato su DB solo alla conferma del form
        // (vedi MspEditImpegno.vue finishImpegno/createImpegno)
        this.$store.dispatch("calendario/setDialog", true);
        this.$router.push("/calendario/impegno/new");
    },

    openFabModalGara: function () {
        // la gara viene creata su DB solo alla conferma del form (vedi MspEditGara.vue
        // finishGara/createGara): qui si apre solo una bozza locale, per evitare righe
        // vuote in calendario_new/gara quando mancano data/sport/specialità/titolo.
        this.$store.dispatch("calendario/setDialog", true);
        this.$router.push("/calendario/gara/new");
    },

    openFabModalNota: function () {
        this.addNota()
            .then( async (result)=>{
                if (result) {
                    let event = result.data.event;
                    await this.$store.dispatch("calendario/addEvent", {event: event.data, type: event.type});
                    let item = this.events.find(el=>+el.id === +event.id);
                    if (item) {
                        this.openModal(item, "add");
                    }
                }
            });
    },

    openLibreriaAllenamenti: function () {
        this.showLibreria = true;
    },

    onLibreriaAdded: function () {
        this.showLibreria = false;
    },

    addTestFromFab: async function () {
        this.$store.dispatch("calendario/setDialog",true);
        this.$router.push("/calendario/test/add");
    },


    addTest: function (data) {
        let url = this.api_base_url+"/api/v2/test.php";
        return new Promise((resolve,reject)=>{
            api(url,'post', data)
                .then((result)=>{
                    if (result.success) {
                        resolve(result.data);
                    } else {
                        resolve(null);
                    }
                })
                .catch((error)=>{
                    reject(error);
                })
        });
    },

    openFabModal: async function (type) {
        //this.showFabModal = true;
        let methods = {
            impegno: "openFabModalImpegno",
            gara: "openFabModalGara",
            nota: "openFabModalNota",
            test: "openFabModalTest",
        };
        this[methods[type]]();
    },

    openPeso: function (id) {
        let mode = (id) ? "edit" : "add";
        let item = {
            type: "peso",
            id: id,
        };
        this.openModal(item, mode);
    },

    openTest: function (id) {
        let item = {
            type: "test",
            id: id,
        };
        this.openModal(item, "edit");
    },

    openAutovalutazione: function (id) {
        let item = {
            type: "autovalutazione",
            id: id,
        };
        this.openModal(item, "edit");
    },

    openAttivita: function (attivita_id) {
        let item = {
            type: "attivita",
            id: attivita_id,
        };
        this.openModal(item);
    },
    openChatCalendario: async function (calendario_id) {
        const newChat = await messaggi.addChat('calendario', calendario_id);
        if (!newChat) return;
        const chatId = newChat.chat_id;
        this.$store.dispatch("calendario/setDialog",true);
        this.$router.push("/chats/"+chatId);
    },

    openModal: function (item, mode="view") {
        if (item.data && item.data.sport_id===this.MSP().ID_RIPOSO) {
            return;
        }
        this.$store.dispatch("calendario/setDialog",true);
        this.setDayFromString(item.start_ymd);
        let paramId;
        if (item.id) {
            paramId = "/"+item.id;
        } else {
            paramId = "";
        }
        if (item.type === "test") {
            const testId = item.data.test_id;
            const date = item.data.data;
            this.$router.push(`/calendario/test/add/${date}/${testId}`);
        } else {
            const path = "/calendario/"+item.type+"/"+mode+paramId;
            let query;
            if (item.type === "allenamento") {
                // Se apri un allenamento abbinato a una attività, apre direttamente la tab feedback.
                const tab = (item.data.attivita_id) ? 1 : 0;
                query = {tab};
            } else {
                query = {};
            }
            const page = {path,query};
            this.$router.push(page);
        }
    },


    setFirstDay: function (day) {
        this.firstDay = day;
    },
    onScrollEnd: function (args) {
        this.setFirstDay(args["first-day"]);
    },


    /* UTILITY*/



    /** Calcola la data partendo dalle coordinate (week, day) relative al giorno di partenza
     * @param {Object} calendar {day: index, week: i_w}
     * @return {Date}
     */
    getDay: function () {
        let inc = 0;
        let newDate = _cal.addDays(this.getStartDay(), inc);
        return newDate;
    },
    getMonth: function (calendar) {
        if (!calendar) {
            return "";
        }
        let newDate = _cal.utcDate(calendar);
        let month =  moment(newDate).format("MMMM YYYY");
        return month;
    },
    getData: function(calendar) {
        let newDate = this.getDay(calendar);
        let formattedDate =  moment(newDate).format("YYYY-MM-DD");

        return formattedDate;
    },


    updateCalendar: function () {
        let start = this.limits.start;
        let end = this.limits.end;
        const n = this.days.length;
        // limiti invariati: niente da ridisegnare
        if (!(n && this.days[0].date === start && this.days[n-1].date === end)) {
            this.days = this.makeDays(start, end);
        }
        this.$forceNextTick(this.osservaSettimane);
    },

    scrollToToday: function () {
        return this.scrollToDay(".oggi")
    },

    scrollToDay: function (selector) {
        //https://github.com/twickstrom/vue-force-next-tick
        return new Promise((resolve,reject)=>{
            this.$forceNextTick(
                ()=>{
                    let container = document.querySelector(".calendar-list");
                    if (!container)
                    {
                        resolve(false);
                        return false;
                    }
                    container.scrollTo(0,10);
                    let today = document.querySelector(selector);
                    if (!today)
                    {
                        resolve(false);
                        return false;
                    }
                    // la settimana del giorno potrebbe essere nascosta (v.
                    // osservaSettimane): va mostrata prima di misurare il giorno
                    const week = today.closest('.calendar-week');
                    if (week) week.classList.remove('calendar-week--fuori');
                    // let bounds = [container, today].map(el=>el.getBoundingClientRect());
                    let bounds = today.getBoundingClientRect();
                    let containerBounds = container.getBoundingClientRect();
                    container.scrollTo(0, bounds.top - containerBounds.top );
                    resolve(true);
                    return true;
                },
                (error)=>{
                    reject(error);
                }
            );


        });
    },

    refresh: function () {
        this.$store.dispatch("messaggio/countCommenti");
        this.forceGoToToday();
    },

    /** Carica la settimana di date e ci porta lo scroll; con reset, svuota prima il
     * calendario. Fino al posizionamento lo scroll infinito è sospeso: svuotato il
     * calendario la lista si accorcia, e un caricamento partito dallo scroll si
     * accavallerebbe a questo (limiti sbagliati, settimane vuote). */
    naviga: async function (date, reset = false) {
        this._navigando = true;
        try {
            if (reset) {
                this.$store.dispatch("calendario/reset");
            }
            await this.loadCalendarDate(date);
            await this.goToDay(date);
        } finally {
            // l'evento di scroll del posizionamento arriva al frame successivo.
            // Poi si controllano i bordi senza aspettare uno scroll: con il giorno in
            // cima (scrollTop 0) o una lista più corta della vista, su iOS non arriva
            // nessun evento e la settimana prima non verrebbe mai caricata.
            this.$forceNextTick(()=>{
                this._navigando = false;
                this.checkInfiniteScroll();
            });
        }
    },
    goToToday: function() {
        return this.naviga(_cal.date2ymd());
    },
    forceGoToTodayIfNeeded: function() {
        let date =  _cal.date2ymd();
        const reset = !_cal.inLimits(this.limits.start, this.limits.end, date);
        return this.naviga(date, reset);
    },
    forceGoToToday: function() {
        return this.naviga(_cal.date2ymd(), true);
    },
    goToDayFromCalendar: function ({id}) {
        return this.naviga(id, true);
    },

    focusDay: async function (Ymd) {
        const calendar = this.$refs.calendar;
        if (!calendar) return;
        await calendar.focusDate(_cal.utcDate(Ymd));
    },

    loadCalendar: async function ({start, end}) {
        const limits = {
            start: start,
            end: end,
        }

        if (!this.atleta) return false;
        this.loading = true;
        await this.$store.dispatch("calendario/loadCalendar",limits);
        this.loading = false;
        return true;
    },

    loadCalendarDate: async function (date) {
        let limits = {
            start: date,
            end: _cal.addDays(date,7),
        }
        const loaded = await this.loadCalendar(limits);
        return loaded;
    },
    goToDay: async function (date) {
        this.setDayFromString(date);
        this.focusDay(date);
        this.updateCalendar();
        await this.scrollToDay("[data-day='"+date+"']");
        // dentro naviga() non fa niente (scroll infinito sospeso): ci pensa naviga
        // al termine del posizionamento
        this.$forceNextTick(this.checkInfiniteScroll);
    },

    appendHistory: function (key, value) {
        let join = (location.search) ? "&" : "?";
        window.history.replaceState("scheda_allenamento", window.document.title, window.location.href+join+key+"="+value);
    },

    loadNext: async function () {
        if (!this.canLoad || this.loadingRange) { return; }
        this.loadingRange = true;
        this.loading = true;
        let caricato;
        try {
            caricato = await this.$store.dispatch("calendario/loadNext");
        } finally {
            this.loading = false;
            this.loadingRange = false;
        }
        if (caricato) {
            this.updateCalendar();
            // lista ancora più corta della vista: continua a caricare
            this.$nextTick(this.checkInfiniteScroll);
        }
    },

    loadPrev: async function () {
        // Durante il rimbalzo/inerzia di iOS lo scroll event scatta a raffica: senza
        // guardia partono più caricamenti concorrenti che modificano scrollTop.
        if (!this.canLoad || this.loadingRange) { return; }
        const container = document.querySelector(".calendar-list");
        const cells = document.querySelector(".calendar-cells");
        if (!(cells && container)) return;
        // riferimento per la compensazione: il primo giorno visibile, non la prima
        // settimana. Se la settimana in cima è parziale (es. caricata da un giovedì)
        // i giorni nuovi entrano anche dentro di lei, sopra il giorno visibile:
        // tenerne fermo il bordo porterebbe la vista all'inizio della settimana.
        const el = this.getFirstDay(container);
        this.loadingRange = true;
        this.loading = true;

        let caricato = false;
        try {
            caricato = await this.$store.dispatch("calendario/loadPrev");
        } finally {
            this.loading = false;
            if (!caricato) {
                this.loadingRange = false;
            }
        }
        if (!caricato) return;

        // posizione del giorno di riferimento prima dell'inserimento in testa
        const prima = el ? el.getBoundingClientRect().top : 0;
        this.updateCalendar();
        // $nextTick e non $forceNextTick: la compensazione va fatta dopo il patch del
        // DOM ma prima del disegno, altrimenti per un frame si vedono le settimane
        // nuove in cima (il doppio requestAnimationFrame lascia passare un disegno)
        this.$nextTick(
            ()=>{
                try {
                    if (el && container && el.isConnected) {
                        // iOS: scrollTop modificato durante l'inerzia congela lo scroller
                        // (touch ignorati). Si blocca l'overflow, si riposiziona e si ripristina.
                        container.style.overflowY = 'hidden';
                        container.scrollTop += el.getBoundingClientRect().top - prima;
                    }
                } finally {
                    if (container) {
                        container.style.overflowY = '';
                    }
                    // sblocco dopo il riposizionamento, per non rilanciare subito un altro
                    // caricamento; poi i bordi, che durante il blocco non sono stati letti
                    setTimeout(()=>{
                        this.loadingRange = false;
                        this.checkInfiniteScroll();
                    }, 300);
                }
            }
        )

    },

    /** Alias di setDay */
    setDayFromString: function (ymd) {
        this.setDay(ymd);
    },

    setDay: function (day) {
        if (day) {
            this.day = day;
        } else {
            this.day = _cal.date2ymd();
        }
        if (this.MSP().url.getParam("day")) {
            window.history.replaceState("scheda_allenamento", window.document.title, window.location.href.replace(/day=[\d|-]+/gi,"day="+this.day));
        } else {
            this.appendHistory("day", this.day);
        }
    },



    makeDays: function (from, to) {
        return _cal.makeDays(from, to);
    },
















    addPesoFromFab: function () {
        this.openPeso(null);
    },

    addPeso: function (data) {
        let url = this.api_base_url+"/api/v2/peso.php";
        return new Promise((resolve,reject)=>{
            api(url,'post', data)
                .then((result)=>{
                    if (result.success) {
                        resolve(result.data);
                    } else {
                        resolve(null);
                    }
                })
                .catch((error)=>{
                    reject(error);
                })
        });
    },


    addMisurazioneFromFab: async function () {
        this.setLastAlertAutovalutazione();
        this.$store.dispatch("calendario/setDialog",true);
        this.$router.push("/calendario/misurazione/add");
    },


    addNota: function () {
        let data = {
            sport_id: 11,
            data: _cal.date2ymd(),
        }
        if (this.isCoach && this.atleta) {
            data.atleta_id = this.atleta.id;
        }
        let url = this.api_base_url+"/api/v2/calendario.php?allenamento";
        return new Promise((resolve,reject)=>{
            api(url,'post', data)
                .then((result)=>{
                    if (result.success) {
                        resolve(result);
                    } else {
                        resolve(null);
                    }
                })
                .catch((error)=>{
                    reject(error);
                })
        });
    },

    getEventColor (event) {
        return event.color
    },
    rnd (a, b) {
        return Math.floor((b - a + 1) * Math.random()) + a
    },

    toggleCalendar ()
    {
        this.collapsed = !this.collapsed;
    },
}
}
export default component;
</script>

<style lang="scss">

.cp-calendar {
    .btn-record {
        color: var(--col-msp);
    }
    .v-speed-dial {
        position: absolute;
        z-index: 5 !important;
    }

    display: flex;
    flex-direction: column;
    justify-content: stretch;
    height: 100%;
    .day-impegno {
        i {
            font-family: "msp";
            font-size: 1em;
            position: relative;
        }
    }
    .day-badges {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 5px;
        i{
            font-size: 1em;
        }

        --color: #fff;

        .day-badge {
            color: var(--color);
            line-height: 1;
            display: flex;
            flex-direction: row;
            gap: 3px;
        }
        .badge-autovalutazione {
            grid-column: 2;
        }
        .badge-peso {
            grid-column: 1;
            --color: #000;
        }
    }
    .calendar-day {


        &.day-range-impegno {
            .day-container {
                background-color: var(--col-grigio-scuro) !important;
                position: relative;
                justify-content: space-between;
            background-color: var(--col-grigio-scuro) !important;
            color: #fff;
            }
        }

    }


    .oggi .day-container{
        background-color: var(--col-ui-evidenza) !important;
    }

    .vc-container {
        .vc-bars {
            align-self: flex-start;
        }
        .vc-focusable {
            &[tabindex="0"]
            {
                border: 2px solid var(--col-msp);

            }
        }
        width: 100%;
        .vc-dot {
            --col: var(--col-grigio-medio);
            &:before {
                content: "";
                display: none;
            }
            background: var(--col);
            &.sport-1 {
                --col: var(--col-sport-1)
            }

            &.sport-2 {
                --col: var(--col-sport-2)
            }

            &.sport-3 {
                --col: var(--col-sport-3)
            }

            &.sport-4 {
                --col: var(--col-sport-4)
            }
            &.sport-5 {
                --col: var(--col-sport-5)
            }
            &.sport-10 {
                --col: var(--col-sport-10)
            }
            &.sport-11 {
                --col: var(--col-sport-11)
            }

        }
    }
    .calendar-list {
        flex: 1;
        flex-basis: 0;
        overflow-y: scroll; /* has to be scroll, not auto */
        // -webkit-overflow-scrolling: touch;
        width: 100%;
        padding-top: 10px;
    }

    .calendar-container {
        &.compact {
            .vc-container {


                --day-min-height: 10px;
                .vc-day {
                    max-height: 15px;
                    overflow: hidden;
                }
            }
        }

        .v-calendar-weekly {
            height: auto;
            &__day {
                display: flex;
                flex-wrap: wrap;
            }
            &__day-label {
                flex-basis: 100%;
            }

        }
        .v-event {
            width: 10px !important;
            height: 10px !important;
            margin: 2px;
            border-radius: 50%;
            overflow: hidden;
            &>div {
                display: none;
            }
        }
        --color: #000;
        transition: all 300ms ease-in-out;
        max-height: 100vh;
        &.collapsed {
            max-height: 0px;
            overflow: hidden;
            margin-bottom: 0px;
        }
    }

    .day-container {
        padding: 10px 20px;
        margin-bottom: 1px;
        background: var(--col-grigio-medio);
        color: #fff;
        display: flex;
        gap: 10px;
    }
}
.fab-label {
  position: absolute;
  right: 100%;
  transform:translateX(-10px);
}
</style>
